import React from 'react';
import './App.css';

import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

import Wamberto from './components/Wamberto';

function App() {
  const path = window.location.pathname
    .replace(/\/+$/, '')
    .toLowerCase();

  if (path === '/wamberto') {
    return (
      <div className="App bg-slate-950 min-h-screen">
        <Wamberto />
      </div>
    );
  }

  return (
    <div className="App bg-slate-950 min-h-screen">
      <Header />

      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProjectsSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}

export default App;